import React, { Component } from 'react';
import TableText from "../../table/TableText";
export const dataDefault = [{
    name: '',
    hotel: '',
    gender: '',
    age: '',
    position: '',
    level: '',
    yearsWork: '',
    hotelYearsWork: '',
    tel: '',
    notes: "",
    sort: 0
}, {
    name: '',
    hotel: '',
    gender: '',
    age: '',
    position: '',
    level: '',
    yearsWork: '',
    hotelYearsWork: '',
    tel: '',
    sort: 1,
    notes: "",
}, {
    name: '',
    hotel: '',
    gender: '',
    age: '',
    position: '',
    level: '',
    yearsWork: '',
    hotelYearsWork: '',
    tel: '',
    sort: 2,
    notes: "",
}, {
    name: '',
    hotel: '',
    gender: '',
    age: '',
    position: '',
    level: '',
    yearsWork: '',
    hotelYearsWork: '',
    tel: '',
    sort: 3,
    notes: "",
}, {
    name: '',
    hotel: '',
    gender: '',
    age: '',
    position: '',
    level: '',
    yearsWork: '',
    hotelYearsWork: '',
    tel: '',
    sort: 4,
    notes: "",
}, {
    name: '',
    hotel: '',
    gender: '',
    age: '',
    position: '',
    level: '',
    yearsWork: '',
    hotelYearsWork: '',
    tel: '',
    sort: 5,
    notes: "",
}];

export const columns = ({ sort, name, onChange }) => {

    return [{
        title: '',
        dataIndex: 'index',
        key: 'index',
        align: "center",
        width: 30,
        render: (text, record, index) => {
            const props = {
                text: (1 + sort) > 3 ? sort - 2 : 1 + sort,
                index: sort,
                type: 'text',
                name: 'index',
            };

            return <TableText data={{ ...props }} />
        }
    }, {
        title: '酒店名称',
        dataIndex: 'hotel',
        key: 'hotel',
        align: "center",
        width: 200,
        render: (text, record, index) => {
            const props = {
                text,
                index: sort,
                type: 'input',
                name: 'hotel',
                onChange,
                totalIndex: [],
                compared: {
                    title: ["酒店名称"],
                    record: { ...record, name },
                    sqlName: "financePersonnel"
                }
            };

            return <TableText data={{ ...props }} />
        }
    }, {
        title: '员工姓名',
        dataIndex: 'name',
        key: 'name',
        width: 100,
        align: "center",
        render: (text, record, index) => {
            const props = {
                text,
                index: sort,
                type: 'input',
                name: 'name',
                onChange,
                totalIndex: [],
                compared: {
                    title: ["员工姓名"],
                    record: { ...record, name },
                    sqlName: "financePersonnel"
                }
            };

            return <TableText data={{ ...props }} />
        }
    }, {
        title: '性别',
        dataIndex: 'gender',
        key: 'gender',
        width: 80,
        align: "center",
        render: (text, record, index) => {
            const props = {
                text,
                index: sort,
                type: 'input',
                name: 'gender',
                onChange,
                totalIndex: [],
                compared: {
                    title: ["性别"],
                    record: { ...record, name },
                    sqlName: "financePersonnel"
                }
            };

            return <TableText data={{ ...props }} />
        }
    }, {
        title: '年龄',
        dataIndex: 'age',
        key: 'age',
        width: 80,
        align: "center",
        render: (text, record, index) => {
            const props = {
                text,
                index: sort,
                type: 'input',
                name: 'age',
                onChange,
                totalIndex: [],
                compared: {
                    title: ["年龄"],
                    record: { ...record, name },
                    sqlName: "financePersonnel"
                }
            };

            return <TableText data={{ ...props }} />
        }
    }, {
        title: '职位',
        dataIndex: 'position',
        key: 'position',
        width: 100,
        align: "center",
        render: (text, record, index) => {
            const props = {
                text,
                index: sort,
                type: 'input',
                name: 'position',
                onChange,
                totalIndex: [],
                compared: {
                    title: ["职位"],
                    record: { ...record, name },
                    sqlName: "financePersonnel"
                }
            };

            return <TableText data={{ ...props }} />
        }
    }, {
        title: '级别',
        dataIndex: 'level',
        key: 'level',
        align: "center",
        width: 100,
        render: (text, record, index) => {
            const props = {
                text,
                index: sort,
                type: 'input',
                name: 'level',
                onChange,
                totalIndex: [],
                compared: {
                    title: ["级别"],
                    record: { ...record, name },
                    sqlName: "financePersonnel"
                }
            };

            return <TableText data={{ ...props }} />
        }
    }, {
        title: '工作年限',
        dataIndex: 'yearsWork',
        key: 'yearsWork',
        width: 100,
        align: "center",
        render: (text, record, index) => {
            const props = {
                text,
                index: sort,
                type: 'input',
                name: 'yearsWork',
                onChange,
                totalIndex: [],
                compared: {
                    title: ["工作年限"],
                    record: { ...record, name },
                    sqlName: "financePersonnel"
                }
            };

            return <TableText data={{ ...props }} />
        }
    }, {
        title: '本酒店工作年限',
        dataIndex: 'hotelYearsWork',
        key: 'hotelYearsWork',
        width: 100,
        align: "center",
        render: (text, record, index) => {
            const props = {
                text,
                index: sort,
                type: 'input',
                name: 'hotelYearsWork',
                onChange,
                totalIndex: [],
                compared: {
                    title: ["本酒店工作年限"],
                    record: { ...record, name },
                    sqlName: "financePersonnel"
                }
            };

            return <TableText data={{ ...props }} />
        }
    }, {
        title: '联系方式',
        dataIndex: 'tel',
        key: 'tel',
        align: "center",
        width: 100,
        render: (text, record, index) => {
            const props = {
                text,
                index: sort,
                type: 'input',
                name: 'tel',
                onChange,
                totalIndex: [],
                compared: {
                    title: ["联系方式"],
                    record: { ...record, name },
                    sqlName: "financePersonnel"
                }
            };

            return <TableText data={{ ...props }} />
        }
    }]
}

export const listData = [
    {
        name: "销售部潜力之星",
        children: 3,
        placeholder: "员工评价（300字以内）"
    },
    {
        name: "销售部支援后备",
        children: 3,
        placeholder: "是否有支援经验，如有，请写明何时何地何酒店，以及支援内容（300字以内）"
    }
];


export const recommend = [
    {
        name: '',
        hotel: '',
        gender: '',
        age: '',
        position: '',
        intention: '',
        area: '',
        tel: '',
        sort: 0
    },
    {
        name: '',
        hotel: '',
        gender: '',
        age: '',
        position: '',
        intention: '',
        area: '',
        tel: '',
        sort: 1
    }, {
        name: '',
        hotel: '',
        gender: '',
        age: '',
        position: '',
        intention: '',
        area: '',
        tel: '',
        sort: 2
    }
];

export const recommendColumns = ({ name, onChange }) => {
    return [
        {
            title: '',
            dataIndex: 'index',
            key: 'index',
            align: "center",
            width: 30,
            render: (text, record, index) => {
                const props = {
                    text: index + 1,
                    index,
                    type: 'text',
                    name: 'index',
                };

                return <TableText data={{ ...props }} />
            }
        },
        {
            title: '员工姓名',
            dataIndex: 'name',
            key: 'name',
            width: 100,
            align: "center",
            render: (text, record, index) => {
                const props = {
                    text,
                    index,
                    type: 'input',
                    name: 'name',
                    onChange,
                    totalIndex: [],
                    compared: {
                        title: ["员工姓名"],
                        record: { ...record, name },
                        sqlName: "financePersonnelRecommend"
                    }
                };

                return <TableText data={{ ...props }} />
            }
        }
        ,
        {
            title: '性别',
            dataIndex: 'gender',
            key: 'gender',
            width: 80,
            align: "center",
            render: (text, record, index) => {
                const props = {
                    text,
                    index,
                    type: 'input',
                    name: 'gender',
                    onChange,
                    totalIndex: [],
                    compared: {
                        title: ["性别"],
                        record: { ...record, name },
                        sqlName: "financePersonnelRecommend"
                    }
                };

                return <TableText data={{ ...props }} />
            }
        }
        ,
        {
            title: '年龄',
            dataIndex: 'age',
            key: 'age',
            width: 80,
            align: "center",
            render: (text, record, index) => {
                const props = {
                    text,
                    index,
                    type: 'input',
                    name: 'age',
                    onChange,
                    totalIndex: [],
                    compared: {
                        title: ["年龄"],
                        record: { ...record, name },
                        sqlName: "financePersonnelRecommend"
                    }
                };

                return <TableText data={{ ...props }} />
            }
        }
        ,
        {
            title: '现酒店',
            dataIndex: 'hotel',
            key: 'hotel',
            width: 300,
            align: "center",
            render: (text, record, index) => {
                const props = {
                    text,
                    index,
                    type: 'input',
                    name: 'hotel',
                    onChange,
                    totalIndex: [],
                    compared: {
                        title: ["现酒店"],
                        record: { ...record, name },
                        sqlName: "financePersonnelRecommend"
                    }
                };

                return <TableText data={{ ...props }} />
            }
        }
        ,
        {
            title: '现职位',
            dataIndex: 'position',
            key: 'position',
            width: 100,
            align: "center",
            render: (text, record, index) => {
                const props = {
                    text,
                    index,
                    type: 'input',
                    name: 'position',
                    onChange,
                    totalIndex: [],
                    compared: {
                        title: ["现职位"],
                        record: { ...record, name },
                        sqlName: "financePersonnelRecommend"
                    }
                };

                return <TableText data={{ ...props }} />
            }
        }
        ,
        {
            title: '意向区域',
            dataIndex: 'area',
            key: 'area',
            width: 100,
            align: "center",
            render: (text, record, index) => {
                const props = {
                    text,
                    index,
                    type: 'input',
                    name: 'area',
                    onChange,
                    totalIndex: [],
                    compared: {
                        title: ["意向区域"],
                        record: { ...record, name },
                        sqlName: "financePersonnelRecommend"
                    }
                };

                return <TableText data={{ ...props }} />
            }
        }
        ,
        {
            title: '意向职位',
            dataIndex: 'intention',
            key: 'intention',
            width: 100,
            align: "center",
            render: (text, record, index) => {
                const props = {
                    text,
                    index,
                    type: 'input',
                    name: 'intention',
                    onChange,
                    totalIndex: [],
                    compared: {
                        title: ["意向职位"],
                        record: { ...record, name },
                        sqlName: "financePersonnelRecommend"
                    }
                };

                return <TableText data={{ ...props }} />
            }
        }
        ,
        {
            title: '联系方式（手机）',
            dataIndex: 'tel',
            key: 'tel',
            width: 150,
            align: "center",
            render: (text, record, index) => {
                const props = {
                    text,
                    index,
                    type: 'input',
                    name: 'tel',
                    onChange,
                    totalIndex: [],
                    compared: {
                        title: ["联系方式（手机）"],
                        record: { ...record, name },
                        sqlName: "financePersonnelRecommend"
                    }
                };

                return <TableText data={{ ...props }} />
            }
        }
    ]
}
export default dataDefault;


// WEBPACK FOOTER //
// ./src/components/otherHeadquartersForms/salesPersonnelAssessment/data.js